import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import { createStore } from 'vuex'
import Antd from 'ant-design-vue';
import 'ant-design-vue/dist/antd.css';
import "./css/global.css"
import i18n from './i18n'
// import store from './store';
//import jquery from 'jquery'
// Vue.prototype.$ = jquery
// const $ = require('jquery');
// window.$ = $;
const $ = require('jquery');
// import VueI18n from 'vue-i18n'
// const jQuery = $;
// We declare it globally
// Vue.prototype.$ = jquery

import { setupI18n } from './lang/index'
window.$ = $;
window.jQuery = $;
String.prototype.hashCode = function(){
    if (Array.prototype.reduce){
        return this.split("").reduce(function(a,b){a=((a<<5)-a)+b.charCodeAt(0);return a&a},0);              
    } 
    var hash = 0;
    if (this.length === 0) return hash;
    for (var i = 0; i < this.length; i++) {
        var character  = this.charCodeAt(i);
        hash  = ((hash<<5)-hash)+character;
        hash = hash & hash; // Convert to 32bit integer
    }
    return hash;
}


const store = createStore({
    state () {
      return {
           count: 0,
           // 定义一个name，以供全局使用
           name: 'dreamforfuture',
           // 定义一个number，以供全局使用
           number: 0,
           reshowtoday:true,
           addchildtaskbox:true,//box是否显示
           // 定义一个list，以供全局使用
           list: [
               { id: 1, name: '111' },
               { id: 2, name: '222' },
               { id: 3, name: '333' },
           ]
      }
    },
    mutations: {
        setshowtodaystate(state, payload) {
            state.reshowtoday = payload.reshowtoday;
        },
        modfifyaddchildboxstatus(state,status){
            state.addchildtaskbox = status
        },
    },
  })


  const app = createApp(App)
  
i18n.global.locale = 'cn'
  setupI18n(app)
  app.use(i18n)
//app.provide('$', jquery);
app.use(router)
app.use(store)
app.use(Antd)
app.mount('#app')